import { render, staticRenderFns } from "./SellFooter.vue?vue&type=template&id=64d15588"
import script from "./SellFooter.vue?vue&type=script&lang=js"
export * from "./SellFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports